import { useSendPasswordResetEmail } from '@hakimo-ui/hakimo/data-access';
import { eventTracker, toast } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import ResetPasswordSentModal from './ResetPasswordSentModal';

export interface Props {
  email: string;
}

export function ResetPassword(props: Props) {
  const { email } = props;
  const [showSentModal, setShowSentModal] = useState(false);
  const mutation = useSendPasswordResetEmail(() => setShowSentModal(true));

  const onClick = () => {
    mutation.mutate(null, {
      onError: () => {
        toast('Could not send the password reset email. Please try again.', {
          type: 'error',
        });
      },
    });
  };

  // The button is taller than a text row. On wide screens the negative margin
  // keeps the row as tall as the others and centres the button on the label's
  // line (with its info icon); on phones the button sits under the label.
  return (
    <>
      <Button
        variant="primary"
        className="py-1.5 sm:-my-1.5"
        onClick={onClick}
        onSideEffect={eventTracker('send_password_reset_email')}
        disabled={mutation.isLoading}
        loading={mutation.isLoading}
        dataTestid="reset-password-button"
      >
        Reset password
      </Button>
      <ResetPasswordSentModal
        open={showSentModal}
        email={email}
        onClose={() => setShowSentModal(false)}
      />
    </>
  );
}

export default ResetPassword;
